module.exports = __webpack_public_path__ + "static/media/400035_01.63f3d48a.png";